/**
 * Based off of http://www.developerdrive.com/2012/03/coding-vendor-prefixes-with-javascript/
 */
function getVendorPrefix(property, prefixedProperties, prefixedOutputProperties) {
	var tempElement = document.createElement('div');

	prefixedProperties.unshift(property);
	if (prefixedOutputProperties)
		prefixedOutputProperties.unshift(property);
	else
		prefixedOutputProperties = prefixedProperties;

	for (let i = 0; i < prefixedProperties.length; ++i) {
		if (typeof tempElement.style[prefixedProperties[i]] !== 'undefined')
			return prefixedOutputProperties[i];
	}

	return property;
}

export const transitionProperty   = getVendorPrefix('transition', [ 'msTransition', 'MozTransition', 'WebkitTransition', 'OTransition' ]);
export const transformProperty    = getVendorPrefix('transform',  [ 'msTransform',  'MozTransform',  'WebkitTransform',  'OTransform'  ]);
export const transformCSSProperty = getVendorPrefix('transform',  [ 'msTransform',  'MozTransform',  'WebkitTransform',  'OTransform'  ], [
	'-ms-transform', '-moz-transform', '-webkit-transform', '-o-transform'
]);



// WEBPACK FOOTER //
// ./assets/scripts/vendor-prefixes.js